// Ziggy
import route from 'ziggy';
import { Ziggy } from '../../ziggy';

const state = {
    countries:[],
};

const getters = {
    getCountries: state => state.countries,
};

const actions = {
    fetchCountries: (store) => {
        if (state.countries.length > 0) {
            return;
        }

        axios.get(route('api.v1.countries', [], true, Ziggy))
            .then(resp => store.commit('COUNTRIES_FETCH', resp.data));
    },
};

const mutations = {
    COUNTRIES_FETCH: (state, payload) => state.countries = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
